export const PERIOD_TYPES = [
  { value: 'days', label: 'Días' },
  { value: 'months', label: 'Meses' },
];
